<style scoped>
	.vue-box {
		background-color: #EEE;font-size: 14px;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}
	.content-box {margin: 1em;padding: 1em;background-color: #FFF;color: #666;}
	.el-tag{border-radius: 1px;}
	/*800之下*/
	@media(max-width: 800px) {
		.kapian {
			width: 100% !important;
			margin-right: 0px !important;
		}
		.saoma {
			display: none;
		}
	}
	/* markdown格式 */
	.md-contetn{padding-left: 1.5em; line-height: 26px;}
</style>
<style>
	/* 多个ul时，切换那个啥 */
	.md-contetn h4{margin-left: -0.5em;}
	.md-contetn ul,.md-contetn ol{padding-left: 1em;}
	.md-contetn pre{padding: 5px; background-color: #EEE; font-family: "times new roman";}
</style>

<template>
	<div class="vue-box">
		<!-- 欢迎 -->
		<div class="content-box">
			<div style="padding: 1em; border-left: 5px #2D8CF0 solid; background-color: #EEE;">
				<big><big>镇江市拼时代机器人培训有限公司会员管理系统</big></big>
				<span style="display: inline-block; margin-left: 1em; color: #888;"> —— 镇江市拼时代机器人培训有限公司 AllRightsReserved</span>
<!--				<el-link type="primary" href="http://sa-admin.dev33.cn/" target="_blank" style="margin-left: 14px;">点我访问</el-link>-->
				<span></span>
			</div>
		</div>
		<!-- 介绍 -->
		<div class="content-box">
			<div class="saoma" style="width: 20%; float: left; margin-right: 4%;">
				<el-divider content-position="left">
					<big><big>系统会员数量</big></big>
				</el-divider>
				<div style="text-align: left;">
<!--					<img src="http://dev33-yxzj.oss-cn-beijing.aliyuncs.com/dyc/img/2020/01/17/157924554064970545739.png" style="width: 60%; margin-left: 10%;">-->

          <div style="font-size: 48px;text-align: center;">{{statisticInfo.studentNum}}</div>
				</div>
			</div>
			<div class="kapian" style="width: 35%; float: left; margin-right: 4%;">
				<el-divider content-position="left">
					<big><big>系统班级数量</big></big>
				</el-divider>
        <div>
          <div style="font-size: 48px;text-align: center;">{{statisticInfo.clazzNum}}</div>
        </div>

			</div>
			<div class="kapian" style="width: 35%; float: left;">
				<el-divider content-position="left">
					<big><big>本月消课数量</big></big>
				</el-divider>
        <div style="font-size: 48px;text-align: center;">{{statisticInfo.finisedClazzCard}}</div>
			</div>
			<div style="clear: both;"></div>
		</div>

		<!-- 功能介绍 -->
		<div class="content-box">
			<div class="kapian" style="width: 35%; float: left; margin-right: 4%;">
				<el-divider content-position="left">
					<big><big>课时不足学生列表</big></big>
				</el-divider>
        <el-table
            :data="statisticInfo.lowHourStudent"
            style="width: 100%">
          <el-table-column
              prop="name"
              label="姓名"
              width="180">
          </el-table-column>
          <el-table-column
              prop="hour"
              label="剩余课时"
              width="180">
          </el-table-column>
        </el-table>
			</div>
			<div class="kapian" style="width: 55%; float: left;">
				<el-divider content-position="left">
					<big><big>老师上课数统计</big></big>
				</el-divider>
        <el-table
            :data="statisticInfo.teaClazzCardNum"
            style="width: 100%">
          <el-table-column
              prop="name"
              label="姓名"
              width="180">
          </el-table-column>
          <el-table-column
              prop="sex"
              label="本月上课数"
              width="180">
          </el-table-column>
        </el-table>
			</div>
			<div style="clear: both;"></div>
		</div>




	</div>
</template>

<script>
	export default {
		data() {
			// 功能介绍
			return {
        statisticInfo:{},
			}
		},
		methods: {
		  getstatisticInfo(){
        this.sa.ajax('api/psdAdmin/getStatisticInfo',
            {},
            function(res){
              if(res.code == '0'){
                this.statisticInfo=res.data;
              }else{
                this.statisticInfo={};
              }
            }.bind(this));
      }
		},
    created() {
      this.getstatisticInfo();
    },
    mounted() {
			// document.querySelectorAll('.md-contetn').forEach(function(item) {
			// 	console.log(item.innerHTML);

			// 	console.log(ds);
			// 	let str = marked(ds);
			// 	item.innerHTML = str;
			// })
		}
	}
</script>

